import { useFirmContext } from '../../providers/FirmProvider';
import { WorkpaperProgress } from '../../types/workpaper';
import { LockClosedIcon } from '@heroicons/react/24/solid';
import { ButtonV2 } from '@cimplico/components';
import { ArrowUpCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';
import BurndownChart from './burndown-chart/BurndownChart';
import ProgressImage from '../../assets/workpaper-insights.png';
import { useHasFeatureAccess } from '../../hooks/use-has-feature-access';

type WorkpaperProgressInsightProps = {
    workpaperProgress: WorkpaperProgress;
};

function WorkpaperProgressInsight({ workpaperProgress }: WorkpaperProgressInsightProps): JSX.Element {
    const canAccessWorkpaperProgressInsight = useHasFeatureAccess('workpaper-progress-insight:read');

    return (
        <div>
            <div className="border-b pb-3">
                <div className="flex gap-4">
                    <h3 className="font-medium text-gray-900 pr-4">Workpaper Progress Insight</h3>
                </div>
            </div>
            <div className="relative pt-4">
                {!canAccessWorkpaperProgressInsight ? <Preview /> : <BurndownChart workpaperProgress={workpaperProgress} />}
            </div>
        </div>
    );
}

function Preview(): JSX.Element {
    const navigate = useNavigate();
    const { shortId } = useFirmContext();
    const { isAdmin } = useIsFirmRole();

    return (
        <div className="relative">
            <div className="flex flex-col justify-center items-center absolute z-10 bottom-1/2 right-1/2 translate-x-1/2 translate-y-1/2 bg-white/90 py-4 px-6 rounded-md shadow-md w-[80%]">
                <LockClosedIcon className="h-6 w-6 text-gray-600" />
                <p className="text-gray-600 mb-2 text-center">
                    Upgrade to the <b>Essential</b> or <b>Professional</b> plan to access this feature
                </p>
                <ButtonV2
                    type="primary"
                    size="sm"
                    label="Upgrade"
                    leftIcon={<ArrowUpCircleIcon />}
                    onClick={(): void => {
                        navigate(`/${shortId}/settings`);
                    }}
                    isDisabled={!isAdmin}
                />
                {!isAdmin && <p className="text-gray-600 mt-2 text-sm">To upgrade, please contact your firm&apos;s administrator</p>}
            </div>
            <div>
                <img src={ProgressImage} className="blur-[4px]" />
            </div>
        </div>
    );
}

export default WorkpaperProgressInsight;
